import(/* webpackMode: "eager", webpackExports: ["AboutExperience"] */ "/var/www/azia_frontv2_green/src/components/about/AboutExperience.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/var/www/azia_frontv2_green/src/components/layout/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/var/www/azia_frontv2_green/src/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeToggle","ThemeSwitch"] */ "/var/www/azia_frontv2_green/src/components/layout/theme-toggle.tsx");
